import React, { useState } from 'react';

import { Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { TextField } from '@mui/material';

import { useForgotPassword } from './useForgotPassword';
import Button from 'components/Button';
import ConfirmForgotPasswordModal from 'components/ConfirmForgotPasswordModal';
import {
  OnboardingContentCenter,
  OnboardingForm,
  OnboardingInputsContainer,
  OnboardingLayout,
} from 'components/OnboardingComponents';
import Text from 'components/Text';

export const ForgotPassword: React.FC = () => {
  const { control, errors, handleSubmit, onSubmit, loading } = useForgotPassword();
  const navigate = useNavigate();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const handleForgotPassword = async (data: any) => {
    const result = await onSubmit(data);
    if (result?.success) {
      setUserEmail(data.email);
      setShowConfirmModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowConfirmModal(false);
    navigate('/login');
  };

  return (
    <OnboardingLayout>
      <OnboardingForm onSubmit={handleSubmit(handleForgotPassword)}>
        <OnboardingContentCenter>
          <Text size="medium" color="textPrimary">
            Informe o e-mail para redefinição de senha
          </Text>
          <OnboardingInputsContainer>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="E-mail"
                  variant="outlined"
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  size="medium"
                />
              )}
            />
          </OnboardingInputsContainer>
          <Button type="submit" loading={loading}>
            Redefinir senha
          </Button>
        </OnboardingContentCenter>
        <Button
          type="button"
          title="Voltar"
          size="medium"
          variant="minimal"
          onClick={() => navigate('/login')}
        >
          Voltar
        </Button>
      </OnboardingForm>

      <ConfirmForgotPasswordModal
        open={showConfirmModal}
        onClose={handleCloseModal}
        email={userEmail}
      />
    </OnboardingLayout>
  );
};

export default ForgotPassword;
